import z from 'zod';

import { passwordSchema } from '@nesso/ui/lib/password.schema';

export const confirmPasswordResetSchema = z.object({
    password: passwordSchema,
});

export type ConfirmPasswordResetValues = z.input<typeof confirmPasswordResetSchema>;
